export const STUDY_TOPIC = '/topic/study';

export enum StudyMessages {
  LogMessage = 'LogMessage',
  ProgressMessage = 'ProgressMessage',
}
